import styled from 'styled-components';
import { theme } from 'assets/styles/theme';

export const CoursesWrapper = styled.div`
  width: 100%;

  .courses-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-wrap: wrap;
    gap: 12px;
    margin-bottom: 10px;
  }

  .courses-header h1 {
    margin: 0;
  }

  .courses-filters {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 14px;
    margin-bottom: 4px;
  }

  .courses-search {
    flex: 1 1 260px;
    max-width: 305px;
  }

  .status-select {
    width: auto;
    min-width: 150px;
  }

  .clear-btn {
    background: none;
    border: none;
    height: auto;
    padding: 0 4px;
    color: ${theme.secondary};
    font-weight: 600;
    cursor: pointer;
  }

  .clear-btn:hover {
    text-decoration: underline;
  }

  .status-tag {
    display: inline-block;
    padding: 2px 10px;
    border-radius: 12px;
    font-size: 11px;
    font-weight: 700;
    text-transform: uppercase;
  }

  .status-tag.active {
    background: rgba(40, 167, 69, 0.12);
    color: #1e7e34;
  }

  .status-tag.archived {
    background: rgba(112, 120, 126, 0.15);
    color: #70787e;
  }

  .no-data {
    padding: 30px 10px;
    text-align: center;
    color: #70787e;
  }
`;

export const ModalOverlay = styled.div`
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.45);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;

  .modal-card {
    width: 100%;
    max-width: 440px;
    background: #fff;
    border-radius: 8px;
    padding: 24px;
    max-height: 90vh;
    overflow-y: auto;
  }

  h2 {
    margin: 0 0 18px;
  }

  label {
    display: block;
    margin-bottom: 14px;
  }

  label > span {
    display: block;
    margin-bottom: 6px;
    font-size: 12px;
    font-weight: 700;
    color: #70787e;
  }

  .form-control {
    width: 100%;
  }

  .field-error {
    margin-bottom: 14px;
    color: #d0021b;
    font-size: 12px;
  }
`;
